export const symphonyApiConfig = {
	apiVersion: process.env.REACT_APP_SYMPHONY_API_VERSION,
};
